import { Injectable } from '@angular/core';
import ChartJs from "chart.js";
import { ChartjsOption } from './chartjs-option.interface';
import { IDataViz } from '../interface/data-viz.interface';
import { ChartElementsOptions } from 'chart.js';

interface ChartElementsOptionsExtended extends ChartElementsOptions {
  Rectangle: {
    extend: any;
  };
}

interface ChartControllers {
  bar:
  {
    extend: any;
  }
  any;
}

@Injectable({
  providedIn: 'root'
})

export class ChartjsGraphsService implements IDataViz {

  private _chartJs: ChartJs;
  private _chartJsOptions: ChartjsOption;
  isPublicLisence: boolean = true;
  version: string = '1.0';
  vizType: string = 'ChartJs';
  vendor: string = '';

  constructor() {
  }

  get chartJs() {
    return this._chartJs;
  }

  init(renderElement: string, optionSet: any) {
    if (renderElement) {
      if (optionSet) {
        let chartData = this.mapDataToChartJs(optionSet);
        if (chartData) {
          this._chartJs = new ChartJs(renderElement, chartData);
        }
        return this._chartJs;
      }
    } else {
      throw `Invalid render element: ${renderElement}`;
    }
  }

  roundedCornersDoughnut() {
    ChartJs.defaults.doughnut = ChartJs.helpers.clone(ChartJs.defaults.doughnut);
    ChartJs.controllers.doughnut = ChartJs.controllers.doughnut.extend({
      draw: function (ease) {
        var ctx = this.chart.chart.ctx;

        var easingDecimal = ease || 1;
        ChartJs.helpers.each(this.getMeta().data, function (arc, index) {
          arc.transition(easingDecimal).draw();

          var vm = arc._view;
          var radius = (vm.outerRadius + vm.innerRadius) / 2;
          var thickness = (vm.outerRadius - vm.innerRadius) / 2;
          var angle = Math.PI - vm.endAngle - Math.PI / 2;

          ctx.save();
          ctx.fillStyle = vm.backgroundColor;
          ctx.translate(vm.x, vm.y);
          ctx.beginPath();
          ctx.arc(radius * Math.sin(angle), radius * Math.cos(angle), thickness, 0, 2 * Math.PI);
          ctx.arc(radius * Math.sin(Math.PI), radius * Math.cos(Math.PI), thickness, 0, 2 * Math.PI);
          ctx.closePath();
          ctx.fill();
          ctx.restore();
        });
      },
    });
  }

  update(dataSet: any, updatedOptions?: any) {
    if (dataSet && this._chartJs) {
      this._chartJs.data = dataSet;
      this._chartJs.update();
    } else {
      throw new Error("Method not implemented.");
    }
  }

  drawNewChart(eleId: string, data: any) {
    if (data && this._chartJs && eleId) {

      let ctx = document.getElementsByTagName('canvas');
      if (ctx.length > 1) {
        for (let i = 0; i < ctx.length; i++) {
          if (ctx[i].id === eleId) {
            this._chartJs.destroy();
            let chartData = this.mapDataToChartJs(data);
            if (chartData) {
              this._chartJs = new ChartJs(ctx[i].id, chartData);
            }
          }
        }
      } else {
        this._chartJs.destroy();
        let chartData = this.mapDataToChartJs(data);
        if (chartData) {
          this._chartJs = new ChartJs(ctx, chartData);
        }
      }
    }
  }

  /**
   * newChartDraw
   */
  public newChartDraw(chart, data) {
    if (chart && data) {
      this._chartJs = chart;
      let ctx = document.getElementsByTagName('canvas');
      if (ctx) {
        for (let i = 0; i < ctx.length; i++) {
          if (ctx[i].id === chart.canvas.id) {
            this._chartJs.destroy();
            let chartData = this.mapDataToChartJs(data);
            if (chartData) {
              this._chartJs = new ChartJs(ctx[i].id, chartData);
            }
            return this._chartJs;
          }
        }
      }
    }
  }


  removeSeries(seriesInfo: any) {
    throw new Error("Method not implemented.");
  }

  setSeries(seriesSet: any) {
    throw new Error("Method not implemented.");
  }

  addAxis(axisSet: any) {
    throw new Error("Method not implemented.");
  }

  /**
     * **Mapping db response data set to DygraphOptions**
     * @param dbResponseDataSet DygraphOptions
     */
  private mapDataToChartJs(dataResponse: any): ChartjsOption {
    let chartformat = (dataResponse && dataResponse.type) ? ((dataResponse.type.toLocaleLowerCase() === 'horizontalbar') ? dataResponse.type : (dataResponse.type.toLocaleLowerCase() === 'polararea') ? dataResponse.type : dataResponse.type.toLocaleLowerCase()) : '';
    if (chartformat) {
      let dataFormat: ChartjsOption = {
        type: chartformat,
        data: dataResponse,
        options: dataResponse.options ? dataResponse.options : "Default Options",
        plugins: dataResponse.plugins ? dataResponse.plugins : []
      }
      return dataFormat;
    } else {
      return;
    }
  }

}
